export default {
  messageType: '프리미엄 동영상',
  title: '프리미엄 동영상 설정',
  label: {
    videoUrl: '동영상 URL',
    thumbnail: '동영상 썸네일 이미지',
    title: '제목',
    content: '내용',
    preview: '동영상 미리보기',
  },
  button: {
    checkVideo: '동영상 확인하기',
  },
  placeholder: {
    link: 'https://를 포함한 URL',
  },
  comment: {
    videoUrl: '카카오TV에 등록된 동영상 링크를 삽입해주세요.',
    thumbnail: '800x800(1:1 비율) 또는 800x400(2:1 비율) 또는 600x800(3:4 비율) 권장 / 최대 500KB',
  },
};
